__turbopack_context__.v({
  "container": "Select-module__QwZTqq__container",
  "error": "Select-module__QwZTqq__error",
  "errorText": "Select-module__QwZTqq__errorText",
  "helperText": "Select-module__QwZTqq__helperText",
  "icon": "Select-module__QwZTqq__icon",
  "label": "Select-module__QwZTqq__label",
  "option": "Select-module__QwZTqq__option",
  "optionIndicator": "Select-module__QwZTqq__optionIndicator",
  "popup": "Select-module__QwZTqq__popup",
  "positioner": "Select-module__QwZTqq__positioner",
  "required": "Select-module__QwZTqq__required",
  "trigger": "Select-module__QwZTqq__trigger",
});
